import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Grid,
  Button,
  TextField,
  FormControl,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import HistoricAppointmentCard from '../../components/Cards/HistoricAppointmentCard';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { isProfessional } from '../../utils/helpers';
import { useStyles } from './style';
import moment from 'moment';
import { SearchOutlined, SettingsBackupRestore } from '@material-ui/icons';
import DoctariSpinner from '../../components/Spinner';
import DoctariModal from '../../components/Modal';

function HistoricAppointments({
  session,
  appointmentsData,
  icdCodesByAppointmentId,
  getAppointmentsAll,
  clearAppointments,
  getConsultationFormat,
  getIcdCodeByAppointmentId,
}) {
  const classes = useStyles();
  const theme = useTheme();

  const [state, setState] = useState({
    fromDate: null,
    toDate: null,
    patientName: null,
    doctorName: null,
    currentPage: null,
  });
  const { currentPage, toDate, fromDate, patientName, doctorName } = state;
  const { appointments, numOfPages } = appointmentsData;
  const [appointmentsLoading, setAppointmentsLoading] = useState(true);
  const [prescriptionModal, setPrescriptionModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState({});

  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search)
    let newState = {
      ...state,
      currentPage: 1,
    }
    if (isProfessional(session.userType)) {
      newState.doctorName = session.name
      
      const urlPatientName = queryParameters.get("patient_name")
      if (urlPatientName && !patientName) {
        newState.patientName = urlPatientName
      }
    } else {
      newState.patientName = session.name
    }
    
    setState(newState)
  }, []);

  function resetFilters() {
    let newState = {
      ...state,
      toDate: '',
      fromDate: '',
      patientName: '',
      doctorName: '',
      currentPage: 1,
    }
    if (isProfessional(session.userType)) {
      newState.doctorName = session.name
    } else {
      newState.patientName = session.name
    }    
    return setState(newState);
  }

  useEffect(() => {
    if (toDate || fromDate || patientName || doctorName || currentPage) {
      searchAppointments();
    }
    return () => clearAppointments();
  }, [toDate, fromDate, patientName, doctorName, currentPage]);

  useEffect(() => {
    console.log('////////////appointmentsData', appointmentsData);
    if (appointments && appointments.length > 0) {
      setAppointmentsLoading(false);
    }
  }, [appointments]);

  const searchAppointments = () => {
    setAppointmentsLoading(true);
    let queryParams = [];
    let queryValues = [];

    const showAllDoctors = process.env.REACT_APP_NAME === "adu";

    if (currentPage > 1) {
      queryParams.push('page');
      queryValues.push(currentPage);
    }
    if (fromDate) {
      queryParams.push('date__gt');
      let fromDateFormatted = moment(fromDate)
        .set('hour', '00')
        .set('minute', '00')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      queryValues.push(fromDateFormatted);
    }
    if (toDate) {
      queryParams.push('date__lt');
      let toDateFormatted = moment(toDate)
        .set('hour', '23')
        .set('minute', '59')
        .tz(process.env.REACT_APP_API_TIMEZONE || 'America/Montevideo')
        .format('YYYY-MM-DD HH:mm');
      queryValues.push(toDateFormatted);
    }
    if (doctorName && !showAllDoctors) {
      queryParams.push('doctor__full_name__icontains');
      queryValues.push(doctorName);
    }
    if (patientName) {
      queryParams.push('patient_name__icontains');
      queryValues.push(patientName);
    }
    getAppointmentsAll(
      session.userType,
      session.id,
      true, //isDone,
      queryParams,
      queryValues
    );
  };

  return (
    <>
      <DoctariModal
        open={prescriptionModal}
        setOpen={(val) => setPrescriptionModal(val)}
        title={'Receta'}
      >
        <Grid
          container
          direction='column'
          justifyContent='center'
          alignItems='center'
          spacing={2}
          style={{ padding: '2rem', width: '100%' }}
        >
          <Grid item xs={12} md={12} className={classes.widthFieldModal}>
            <TextField
              id='standard-basic'
              label='Prescripción por Genérico'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              InputProps={{
                readOnly: true,
              }}
              defaultValue={selectedPrescription.generic_drug || ''}
            />
          </Grid>
          <Grid item xs={12} md={12} className={classes.widthFieldModal}>
            <TextField
              id='standard-basic'
              label='Forma Farmacéutica'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              InputProps={{
                readOnly: true,
              }}
              defaultValue={selectedPrescription.pharmaceutical_form || ''}
            />
          </Grid>
          <Grid item xs={12} md={12} className={classes.widthFieldModal}>
            <TextField
              id='standard-basic'
              label='Posología'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              InputProps={{
                readOnly: true,
              }}
              defaultValue={selectedPrescription.posology || ''}
            />
          </Grid>
          <Grid item xs={12} md={12} className={classes.widthFieldModal}>
            <TextField
              id='standard-basic'
              label='Vía de Administración'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              InputProps={{
                readOnly: true,
              }}
              defaultValue={selectedPrescription.delivery_route || ''}
            />
          </Grid>
          <Grid item xs={12} md={12} className={classes.widthFieldModal}>
            <TextField
              id='standard-basic'
              label='Concentración'
              variant='standard'
              style={{ width: '100%' }}
              // className={styles.paperGridItems}
              InputProps={{
                readOnly: true,
              }}
              defaultValue={selectedPrescription.concentration || ''}
            />
          </Grid>
        </Grid>
        {/* <Box
          style={{ display: 'flex', justifyContent: 'end', padding: '2rem' }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => handlePatchAppointmentLight()}
          >
            {appointmentsData.loading ? 'Cargando...' : 'Aceptar'}
          </Button>
        </Box> */}
      </DoctariModal>
      <Grid container style={{ display: 'block', marginTop: '2rem' }}>
        <div className={classes.generalContainer}>
          <Grid className={classes.formContainer}>
            <span style={{ fontWeight: 400, fontSize: '24px' }}>
              Buscar historial
            </span>
            {isProfessional(session.userType) ? (
              <TextField
                className={classes.search}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <IconButton>
                        <SearchOutlined />
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: {
                    height: '46px',
                  },
                  classes: { underline: classes.underline },
                }}
                id='my-input'
                placeholder='Nombre de paciente'
                variant='standard'
                autoComplete='off'
                value={patientName}
                onChange={(e) =>
                  setState({
                    ...state,
                    patientName: e.target.value,
                    currentPage: 1,
                  })
                }
              />
            ) : (
              <TextField
                className={classes.search}
                InputProps={{
                  startAdornment: (
                    <InputAdornment>
                      <IconButton>
                        <SearchOutlined />
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: {
                    height: '46px',
                  },
                  classes: { underline: classes.underline },
                }}
                id='my-input'
                placeholder='Nombre de doctor'
                variant='standard'
                autoComplete='off'
                value={doctorName}
                onChange={(e) =>
                  setState({
                    ...state,
                    doctorName: e.target.value,
                    currentPage: 1,
                  })
                }
              />
            )}
            <Grid item className={classes.gridItem}>
              {/*   {isProfessional(session.userType) ? (
                <Grid item md={2}>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor='my-input-patient'>Paciente</InputLabel>
                    <Input
                      id='my-input-patient'
                      aria-describedby='my-helper-text'
                      onChange={(e) =>
                        setState({ ...state, patientName: e.target.value })
                      }
                      value={patientName}
                    />
                  </FormControl>
                </Grid>
              ) : (
                <Grid item >
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor='my-input-patient'>Doctor</InputLabel>
                    <Input
                      id='my-input-patient'
                      aria-describedby='my-helper-text'
                      onChange={(e) =>
                        setState({ ...state, doctorName: e.target.value })
                      }
                      value={doctorName}
                    />
                  </FormControl>
                </Grid>
              )} */}
              <FormControl className={classes.formControl}>
                {/* <TextField
                  id="fromDate"
                  label="Desde"
                  type={!fromDate ? 'text' : 'date'}
                  value={fromDate}
                  onChange={(e) =>
                    setState({
                      ...state,
                      fromDate: e.target.value,
                      currentPage: 1,
                    })
                  }
                  onFocus={(e) => (e.target.type = 'date')}
                  onBlur={(e) => (e.target.type = !fromDate ? 'text' : 'date')}
                /> */}
                <TextField
                  id='fromDate'
                  label='Desde'
                  type='date'
                  value={fromDate}
                  onChange={(e) =>
                    setState({
                      ...state,
                      fromDate: e.target.value,
                      currentPage: 1,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item className={classes.gridItem}>
              <FormControl className={classes.formControl}>
                <TextField
                  id='toDate'
                  label='Hasta'
                  type='date'
                  value={toDate}
                  onChange={(e) =>
                    setState({
                      ...state,
                      toDate: e.target.value,
                      currentPage: 1,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </FormControl>
            </Grid>
            <Grid className={classes.buttonContainer}>
              <Button
                variant='contained'
                onClick={() => resetFilters()}
                style={{
                  color: 'white',
                  backgroundColor: '#666666',
                }}
              >
                <SettingsBackupRestore />
                Reiniciar
              </Button>
              <Button
                variant='contained'
                onClick={() => searchAppointments()}
                style={{
                  color: 'white',
                  backgroundColor: theme.palette.primary.main,
                  marginLeft: 'auto',
                }}
              >
                Filtrar
              </Button>
            </Grid>
          </Grid>
          <Grid className={classes.cardContainer}>
            {
              <>
                {appointmentsData.loading ? (
                  <DoctariSpinner />
                ) : appointments.length > 0 ? (
                  appointments.map((appointment) => {
                    return (
                      <HistoricAppointmentCard
                        key={appointment.id}
                        appointment={appointment}
                        isProfessional={isProfessional(session.userType)}
                        setPrescriptionModal={setPrescriptionModal}
                        setSelectedPrescription={setSelectedPrescription}
                        getConsultationFormat={getConsultationFormat}
                        getIcdCodeByAppointmentId={getIcdCodeByAppointmentId}
                        appointmentIcdCodes={
                          icdCodesByAppointmentId[appointment.id]?.codes || []
                        }
                        icdCodesLoading={
                          icdCodesByAppointmentId[appointment.id]?.loading ||
                          false
                        }
                      />
                    );
                  })
                ) : (
                  <h3>No hay consultas</h3>
                )}
              </>
            }

            {true && (
              <Pagination
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '2rem',
                  marginBottom: '2rem',
                }}
                page={currentPage}
                count={numOfPages}
                onChange={(_, page) => {
                  console.log(page);
                  if (currentPage !== page) {
                    setState({ ...state, currentPage: page });
                  }
                }}
                variant='outlined'
                color='primary'
              />
            )}
          </Grid>
        </div>
      </Grid>
    </>
  );
}

const mapStateToProps = ({ session, appointments }) => {
  return {
    session,
    appointmentsData: appointments,
    icdCodesByAppointmentId: appointments.icdCodesByAppointmentId || {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAppointments: (userType, id, isDone, queryParams, queryValues) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS,
      payload: {
        userType,
        id,
        isDone,
        queryParams,
        queryValues,
      },
    }),

  getAppointmentsLight: (userType, id, isDone, queryParams, queryValues) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS_LIGHT,
      payload: {
        userType,
        id,
        isDone,
        isPayed: true,
        queryParams,
        queryValues,
      },
    }),

  getAppointmentsAll: (userType, id, isDone, queryParams, queryValues) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS_ALL, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        userType,
        id,
        isDone,
        queryParams,
        queryValues,
      },
    }),

  clearAppointments: () =>
    dispatch({ type: appointmentActionsTypes.CLEAR_APPOINTMENTS }),

  getConsultationFormat: (appointmentId) =>
    dispatch({
      type: appointmentActionsTypes.GET_CONSULTATION_FORMAT,
      payload: {
        appointmentId,
      },
    }),

  getIcdCodeByAppointmentId: (appointmentId) =>
    dispatch({
      type: appointmentActionsTypes.GET_ICD_CODE_BY_APPOINTMENT_ID,
      payload: {
        appointmentId,
      },
    }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HistoricAppointments);
